import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import "./i18n";
import "./Components/Css/loading.scss";

// Centralized Axios diagnostics to quickly locate failing endpoints.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status ?? "NETWORK";
    const method = (error?.config?.method || "get").toUpperCase();
    const url = error?.config?.url || "unknown-url";
    console.error(`[Axios ${status}] ${method} ${url}`);
    return Promise.reject(error);
  },
);

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={"/monitoring"}>
      <Suspense fallback={<div></div>}>
        <App />
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root"),
);
